// src/components/Loading/CustomLoading.tsx

import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import LogoSpinner from "../Commons/Loading/LogoSpinner";
import "./CustomLoading.css";

export default function CustomLoading()
{


  const commonSytem = useSelector((state: RootState) => state.appCommonSlice.commonSystem)

  return (
    <div className="custom-loading-overlay" style={{

      minHeight: "100vh",
    }}>
      <div className="custom-loading-content">
        <center>
          {/* Same spinner as every other loading state, just bigger. */}
          <LogoSpinner size={96} />
        </center>

        <h1
          className="custom-loading-title mt-4 text-[var(--color-main-text)]"

        >
          {commonSytem?.titleApp ?? 'VMRS'}
        </h1>
        <div className="custom-loading-bar">
          <div className="custom-loading-progress"></div>
        </div>
      </div>
    </div>
  );
}
